export const refreshAuthToken = (
  client_id,
  client_secret,
  redirect_uri,
  code_verifier,
  path,
  url,
  setUserKey,
  setTokenRefreshing,
  nextAction,
  setLoading
) => {
  const refreshToken = JSON.parse(
    localStorage.getItem("user-trial-data")
  )?.refresh_token
  const myHeaders = new Headers()
  let code
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded")
  myHeaders.append(
    "Authorization",
    "Basic " + Buffer.from(client_id + ":" + client_secret).toString("base64")
  )
  const urlencoded = new URLSearchParams()
  urlencoded.append("grant_type", "refresh_token")
  urlencoded.append("redirect_uri", redirect_uri)
  urlencoded.append("code_verifier", code_verifier)
  urlencoded.append("client_id", client_id)
  urlencoded.append("refresh_token", refreshToken)
  urlencoded.append("state", path)

  if (setTokenRefreshing) {
    setTokenRefreshing(true)
  } 
  // create our options
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  }
  fetch(url, requestOptions)
    .then(response => response.text())
    .then(result => {
      if (result) {
        code = refreshToken
        const updatedRes = JSON.parse(result)
        if (updatedRes?.access_token) {
          localStorage.setItem(
            "user-trial-data",
            JSON.stringify({
              id: updatedRes?.access_token,
              time: Date.now(),
              idTokenForLogout: updatedRes?.id_token,
              refresh_token: updatedRes?.refresh_token,
            })
          )
          if (nextAction) {
            nextAction()
          }
          if (setUserKey) setUserKey({
              id: updatedRes?.access_token,
              time: Date.now(),
              idTokenForLogout: updatedRes?.id_token,
              refresh_token: updatedRes?.refresh_token,
            })
          if (setTokenRefreshing) setTokenRefreshing(false)
          if (setLoading) setLoading(false)
        } else {
          localStorage.removeItem("user-trial-data")
          localStorage.removeItem("user_info")
          localStorage.removeItem("item_")
          localStorage.removeItem("timeStamp")
          localStorage.removeItem("id_link")
          localStorage.removeItem("currency")
          localStorage.removeItem("country")
          sessionStorage.removeItem("accountSelector")
          sessionStorage.removeItem("accountConfirmation")
          if (setTokenRefreshing) setTokenRefreshing(false)
          if (setLoading) setLoading(false)
        }
      }
    })
    .catch(error => {
      console.log("error", error)
    })
}
 
